export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5100.ec67d604.jpg";